import { storableError } from '../../util/errors';
import { fetchSeoVenuesIndex } from '../../util/seoDiscoveryFetch';

export const FETCH_INDEX_REQUEST = 'app/SeoDiscoveryVenuesIndexPage/FETCH_REQUEST';
export const FETCH_INDEX_SUCCESS = 'app/SeoDiscoveryVenuesIndexPage/FETCH_SUCCESS';
export const FETCH_INDEX_ERROR = 'app/SeoDiscoveryVenuesIndexPage/FETCH_ERROR';

const initialState = {
  data: null,
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_INDEX_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_INDEX_SUCCESS:
      return { ...state, fetchInProgress: false, data: payload };
    case FETCH_INDEX_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

const fetchIndex = query => dispatch => {
  dispatch({ type: FETCH_INDEX_REQUEST });
  return fetchSeoVenuesIndex(query)
    .then(data => dispatch({ type: FETCH_INDEX_SUCCESS, payload: data }))
    .catch(e => dispatch({ type: FETCH_INDEX_ERROR, payload: storableError(e) }));
};

/** Hub: letter counts only — crawlable venue links live on /venues/letter/:letter/ pages. */
export const loadData = () => dispatch =>
  dispatch(
    fetchIndex({
      launched: 'true',
      sort: 'name',
      limit: '0',
    })
  );
